import React, { useState } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

export function MouseoverRenderedTooltip({ children, ...rest }: TooltipProps) {
  const [renderTooltip, setRenderTooltip] = useState(false);

  return (
    <div onMouseEnter={() => !renderTooltip && setRenderTooltip(true)}>
      {!renderTooltip && children}
      {renderTooltip && (
        <Tooltip PopperProps={{ sx: { pointerEvents: 'none', '& .MuiTooltip-tooltip': { maxWidth: 600 } } }} {...rest} placement="bottom-start">
          {children}
        </Tooltip>
      )}
    </div>
  );
}
